// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XTable_XTable__O1lWG {
  display: "table";
}

.XTable_XTableRow__6x-2W {
  display: table-row;
}

.XTable_XTableCell__Rzdqz {
  display: table-cell;
}`, "",{"version":3,"sources":["webpack://./src/X/styles/XTable.module.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;;AACA;EACI,kBAAA;AAEJ;;AAAA;EACI,mBAAA;AAGJ","sourcesContent":[".XTable {\n    display: \"table\";\n}\n.XTableRow {\n    display: table-row;\n}\n.XTableCell {\n    display: table-cell;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"XTable": `XTable_XTable__O1lWG`,
	"XTableRow": `XTable_XTableRow__6x-2W`,
	"XTableCell": `XTable_XTableCell__Rzdqz`
};
export default ___CSS_LOADER_EXPORT___;
